<kui-snackbar-item *ngFor="let item of _items"
    @fade
    [title]="item.title"
    [description]="item.description"
    [icon]="item.icon"
    [duration]="item.duration"
    [actionText]="item.actionText"
    (onActionClicked)="handleActionClicked(item)"
    (onClosed)="removeItem(item)"></kui-snackbar-item>
